import React, { useState, useRef, useEffect } from "react";
import "./Select.css";
import logo from "./images/trampulins_logo.png";
import SelectList from "./SelectList";
import SelectItem from "./SelectItem";
import Preloader from "./Preloader";
import Summary from "./Summary";
import Size from "./Size";
import SummaryConfig from "./SummaryConfig";
import {
  SwitchTransition,
  TransitionGroup,
  CSSTransition,
} from "react-transition-group";
import Total from "./Total";
import SummaryConfigMobile from "./SummaryConfigMobile";
function Select(props: any) {
  const [isImageLoaded, setImageLoaded] = useState(false);
  const [showcaseImg, setShowcaseImage] = useState<HTMLImageElement>(
    new Image()
  );
  const sizeRefs = useRef<any>(null);

  let showCaseClass = "Select-showcase";
  let showCaseBg;
  let urlForBg;
  let bgSize;
  const [viewport_width, setViewPortWidth] = React.useState(window.innerWidth);

  let drawHeight = 340,
    drawLenght = 670;
  useEffect(() => {
    window.addEventListener("resize", () =>
      setViewPortWidth(window.innerWidth)
    );
  }, []);

  // React.useEffect(() => {
  //   if (sizeRefs.current && props.konfigured["width"] === undefined) {
  //     props.onInitSelect(sizeRefs.current.SizeWidthSet());
  //   }
  //   if (sizeRefs.current && props.konfigured["length"] === undefined) {
  //     props.onInitSelect(sizeRefs.current.SizeLengthSet());
  //   }
  // }, [props.category, props.konfigured]);

  React.useEffect(() => {
    setImageLoaded(false);
    const bgEl = document.querySelector(".Select-CaseBg") as HTMLElement;
    //setShowcaseImage(new Image());
    if (bgEl) bgEl.style.backgroundImage = `url(${props.prevShowcase})`; //props.prevShowcase;
    showcaseImg.onload = function () {
      setImageLoaded(true);
      if (bgEl) bgEl.style.backgroundImage = `url(${showcaseImg.src})`;
    };
    showcaseImg.src = props.showcase;
  }, [props.showcase]);

  if (!props.isLoaded) {
    showCaseClass += " blur";
  }

  if (!isImageLoaded) {
    urlForBg = props.prevShowcase;
    showCaseClass += " blur";
  }
  if (isImageLoaded) {
    urlForBg = showcaseImg.src;
  }

  useEffect(() => {
    if (props.currentCategory === "parameters") {
      setImageLoaded(true)
    }
  }, [props.currentCategory])


  bgSize = `60%`;

  showCaseBg = {
    // backgroundImage: `url(${urlForBg})`,
    backgroundRepeat: `no-repeat`,
    backgroundSize: bgSize,
    backgroundPosition: `center center`,
  };

  let selectSideMobileTotal = {
    height: `100vh`,
    background: `white`,
    'z-index': `3`,
  };
  // if (viewport_width <= 778 && props.currentCategory === "summary") {
  //   selectSideMobileTotal = {
  //     height: `100vh`,
  //     background: `white`,
  //     zIndex: `3`,
  //   };
  // }

  let mapDescription = (description: string) => {
    if (description) {
      const descArr = description.split(";");
      const descArrMod = descArr.map((el: string) => el.split(":"));
      return descArrMod.map((el) => (
        <div className="Desk" key={el[0]}>
          <span className="Desk-title">{el[0]}: </span>
          <span className="Desk-text">{el[1]}</span>
        </div>
      ));
    }
  };

  return (
    <div className="Select">
      <div className="Select-side" style={viewport_width <= 778 && props.category === "summary" ? selectSideMobileTotal: {}}>
        <div className="Select-side-inner">
          {props.selects ? (
            <TransitionGroup component={null}>
              <CSSTransition
                timeout={300}
                in={true}
                key={props.category}
                classNames="fade"
              >
                <SelectList
                  selects={props.selects}
                  konfigured={props.konfigured}
                  onSelectChange={props.onSelectChange}
                  category={props.category}
                  name=""
                ></SelectList>
              </CSSTransition>
            </TransitionGroup>
          ) : (
            ""
          )}
          {props.category === "parameters" ? (
            <TransitionGroup>
              <CSSTransition
                timeout={300}
                in={true}
                key={props.category}
                classNames="fade"
              >
                {viewport_width <= 992 ? (
                  <SummaryConfigMobile
                    konfigured={props.konfigured}
                    selects={props.selects}
                    luverSelects={props.luverSelects}
                    setLuversCount={props.setLuversCount}
                    onSelectChange={props.onSelectChange}
                  ></SummaryConfigMobile>
                ) : (
                  <SummaryConfig
                    konfigured={props.konfigured}
                    selects={props.selects}
                    luverSelects={props.luverSelects}
                    setLuversCount={props.setLuversCount}
                    onSelectChange={props.onSelectChange}
                  ></SummaryConfig>
                )}
              </CSSTransition>
            </TransitionGroup>
          ) : (
            ""
          )}
          {props.category === "summary" ? (
            <TransitionGroup>
              <CSSTransition
                timeout={300}
                in={true}
                key={props.category}
                classNames="fade"
              >
                <Total
                  drawing={props.drawing}
                  price={props.price}
                  quantityHandle={props.quantityHandle}
                  konfigured={props.konfigured}
                ></Total>
              </CSSTransition>
            </TransitionGroup>
          ) : (
            ""
          )}
        </div>
        <div className="logo-wrapper">
          {" "}
          <img src={logo} alt="" />
        </div>
      </div>
      <div className="Select-area">
        <div className="Select-description">
          {mapDescription(props.description)}
        </div>
        {props.selects && props.selects.length > 0 ? (
          <div className={showCaseClass}>
            <div className="Select-CaseBg" style={showCaseBg}></div>
          </div>
        ) : (
          <div className="Size-parent">
            <Size
              color={props.color}
              className="Select-size"
              ref={sizeRefs}
              screenshotHadle={props.screenshotHadle}
              category={props.category}
              konfigured={props.konfigured}
            ></Size>
          </div>
        )}

        <Preloader
          isImageLoaded={isImageLoaded}
          isLoaded={props.isLoaded}
        ></Preloader>
        <Summary
          drawing={props.drawing}
          konfigured={props.konfigured}
          price={props.price}
          chosenElements={props.chosenElements}
        ></Summary>
      </div>
    </div>
  );
}

export default Select;
